// extracted by mini-css-extract-plugin
module.exports = {"dropdownIcon":"messageModal_dropdownIcon__1nOGe","dropdownFilesWidth":"messageModal_dropdownFilesWidth__2M6jq"};